import { Controller } from "@hotwired/stimulus";
import { enter, leave } from "el-transition";

export default class extends Controller {
  static values = {
    id: String,
    persist: Boolean,
  };
  static targets = ["container", "overlay", "content", "test"];

  connect() {
    this.testTarget.addEventListener("turbo:frame-load", this.open.bind(this));
    this.testTarget.addEventListener(
      "turbo:submit-end",
      this.handleSubmit.bind(this)
    );
    this.isOpen = false;
    addEventListener("keydown", this.keydown.bind(this));
  }

  disconnect() {
    this.testTarget.removeEventListener("turbo:frame-load", this.open);
    removeEventListener("keydown", this.keydown.bind(this));
  }

  keydown(event) {
    if (event.keyCode === 27) {
      this.close();
    }
  }

  open() {
    if (this.isOpen) return;
    enter(this.containerTarget);
    Promise.all([enter(this.overlayTarget), enter(this.contentTarget)]).then(
      () => {
        this.isOpen = true;
      }
    );
  }

  close() {
    Promise.all([leave(this.overlayTarget), leave(this.contentTarget)]).then(
      () => {
        leave(this.containerTarget);
        this.isOpen = false;
      }
    );
    // This will prevent modals from re-rendering when you click back.
    this.modalTurboFrame.src = null;
  }

  handleSubmit = (e) => {
    const submitter = e.detail.formSubmission.submitter;
    const name = submitter ? submitter.name : false;
    const value = submitter ? submitter.value : false;
    const persistValue = this.persistValue;

    console.log(submitter, name, value, persistValue);
    if (
      !persistValue &&
      !(name === "persist_modal" && value) &&
      e.detail.success
    ) {
      this.close();
    }
  };

  get modalTurboFrame() {
    return document.querySelector("turbo-frame[id='" + this.idValue + "']");
  }
}
